export default {
    id: 1,
    mediaFormIsExperienceDisabled: (mediaFullForm) => mediaFullForm.valid_cdl === 'no',
    mediaFormUpdated: (newValues, mediaFormThis) => {
        if (newValues.valid_cdl  === 'no') mediaFormThis.mediaFullForm.experience = '0'
    },
    getFormTypeInputFields: () => [
        {
            name: 'valid_cdl',
            options: 'yes-no',
            validation: {
                required: 'Valid CDL field is required',
            },
        },
        'experienceFields',
        {
            name: 'valid_driver_license',
            options: 'yes-no',
            validation: {
                required: 'Valid driver license field is required',
            },
            show: (fields) => (fields.valid_driver_license || '').toLowerCase() === 'yes'
        },
        {
            name: 'owner_operator',
            options: 'yes-no',
            validation: {
                required: 'Owner operator field is required',
            },
            show: (fields) => (fields.owner_operator || '').toLowerCase() === 'yes'
        },
    ],
}
